// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","grey-font-color":"#000000","title":"Nlw82xO","title_white":"_2WLNEJe Nlw82xO"};